<aside class="left-sidebar" [class.sb--mini]="isMini">

  <!-- Brand -->
  <div class="sb-brand">
    <a routerLink="/" class="sb-logo" *ngIf="!isMini">
      <img src="assets/images/logo_dark.svg" alt="Clina" />
    </a>
    <div class="sb-logo sb-logo--icon" *ngIf="isMini">
      <img src="assets/images/favicon.svg" alt="Clina" />
    </div>
  </div>

  <!-- Nav -->
  <nav class="sb-nav">
    <ng-container *ngFor="let group of visibleModel">
      <p class="sb-group" *ngIf="!isMini">{{ group.label }}</p>
      <a
        *ngFor="let item of group.items"
        class="sb-item"
        [class.sb-item--mini]="isMini"
        [routerLink]="item.routerLink ? ['/' + item.routerLink] : null"
        routerLinkActive="sb-item--active"
        (mouseenter)="onItemEnter(item, $event)"
        (mouseleave)="onItemLeave()"
        (click)="onItemClick(item, $event, logoutModal)">
        <lucide-icon [name]="item.icon" [size]="17" class="sb-item__icon"></lucide-icon>
        <span class="sb-item__label" *ngIf="!isMini">{{ item.label }}</span>
      </a>
    </ng-container>
  </nav>

  <!-- Tooltip -->
  <div class="sb-tooltip" *ngIf="tooltipLabel && isMini" [style.top.px]="tooltipY">
    {{ tooltipLabel }}
  </div>

  <!-- Footer -->
  <div class="sb-footer" [class.sb-footer--mini]="isMini">
    <div class="sb-user" *ngIf="user && !isMini">
      <div class="sb-user__avatar">{{ getInitials(user.name) }}</div>
      <div class="sb-user__info">
        <span class="sb-user__name">{{ user.name }}</span>
        <span class="sb-user__role">Administrador</span>
      </div>
    </div>
    <div class="sb-user__avatar" *ngIf="user && isMini" [title]="user.name">
      {{ getInitials(user.name) }}
    </div>
    <span class="sb-version" *ngIf="!isMini">
      <span class="sb-version__dot"></span>
      v1.0.0
    </span>
  </div>

</aside>

<ng-template #logoutModal>
  <div class="modal-header">
    <h5 class="modal-title">Confirmar saída</h5>
    <button type="button" class="btn-close" (click)="modalRef?.hide()"></button>
  </div>
  <div class="modal-body">Tem certeza que deseja sair da aplicação?</div>
  <div class="modal-footer">
    <button class="cl-btn cl-btn--secondary" (click)="modalRef?.hide()">Cancelar</button>
    <button class="cl-btn cl-btn--danger" (click)="confirmLogout()">Sair</button>
  </div>
</ng-template>
